import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';
import insuranceApi from '../../utils/api/insuranceApi';

export const getStatistic = createAsyncThunk(
    'statistic/getStatistic',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.get(
                `api/v1/statistic/kpi?from_date=${body.from_date}&to_date=${body.to_date}&client_id=${body.client_id}`,
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const getInsuranceStatistic = createAsyncThunk(
    'statistic/getInsuranceStatistic',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await insuranceApi.get(
                `api/v1/statistics?month=${body.month}&year=${body.year}&client=${body.client}`,
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

const initialState = {
    statisticLoadingStatus: 'idle',
    statistic: [],
    insuranceStatistic: null,
    errors: {},
};

export const statisticSlice = createSlice({
    name: 'statistic',
    initialState,
    reducers: {},
    extraReducers: {
        [getStatistic.pending]: (state, action) => {
            state.statisticLoadingStatus = 'loading';
        },
        [getStatistic.fulfilled]: (state, action) => {
            state.statistic = action.payload;
            state.statisticLoadingStatus = 'succeeded';
        },
        [getStatistic.rejected]: (state, action) => {
            state.statisticLoadingStatus = 'failed';
            state.errors = action.error;
        },

        [getInsuranceStatistic.pending]: (state, action) => {
            state.statisticLoadingStatus = 'loading';
        },
        [getInsuranceStatistic.fulfilled]: (state, action) => {
            state.insuranceStatistic = action.payload;
            state.statisticLoadingStatus = 'succeeded';
        },
        [getInsuranceStatistic.rejected]: (state, action) => {
            state.statisticLoadingStatus = 'failed';
            state.errors = action.error;
        },
    },
});

/* Selectors */
export const allStatistic = (state) => state.statistic.statistic;
export const insuranceStatistic = (state) => state.statistic.insuranceStatistic;
export const statisticLoadingStatus = (state) =>
    state.statistic.statisticLoadingStatus;

export default statisticSlice.reducer;
